'use client';

import { DriftClient } from '@drift-labs/sdk';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftClientIsReady from './useDriftClientIsReady';

const useDriftClient = (): DriftClient | undefined => {
	const isDriftClientReady = useDriftClientIsReady();
	const driftClient = useDriftStore((s) => s.driftClient?.client);

	return isDriftClientReady ? driftClient : undefined;
};

export default useDriftClient;
